import { Sun, Moon } from 'lucide-react';
import useTheme from '../hooks/useTheme';

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggle}
      title={isDark ? 'Tema claro' : 'Tema escuro'}
      className="relative w-14 h-7 rounded-full bg-card border border-border flex items-center transition-colors hover:border-accent/50"
    >
      <span
        className="absolute top-0.5 w-6 h-6 rounded-full bg-accent flex items-center justify-center text-white transition-all shadow"
        style={{ left: isDark ? '2px' : 'calc(100% - 26px)' }}
      >
        {isDark ? <Moon className="w-3.5 h-3.5" /> : <Sun className="w-3.5 h-3.5" />}
      </span>
    </button>
  );
}
